import { SubscriptionBookingStatus } from '@platform-frontend/checkout-drop-in';
import { PricingInformation } from '../../pricing-information';
import { AssetDetails } from './asset-details';

export interface SubscriptionDetails<T = SubscriptionBookingStatus> extends AssetDetails {
  confirmedPricingInformation: PricingInformation;
  confirmedTermsVersion: string | null;
  bookingStatus: T;
  endOfNoticePeriod: Date | null; // This could potentially moved inside the bookingStatus since it is only set for ongoing subscriptions
  endOfPeriod: Date;
  terminationDate: Date;
  webCheckoutLink: string;
  subscriptionManagementLink: string;
}
